import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import DynamicBackground from '../components/DynamicBackground';

const NotFoundContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

const Content = styled.div`
  text-align: center;
  color: white;
  z-index: 1;
  padding: 2rem;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 12px;
`;

const Title = styled.h1`
  font-size: 4rem;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  font-size: 1.5rem;
  margin-bottom: 2rem;
`;

const StyledLink = styled(Link)`
  display: inline-block;
  padding: 12px 24px;
  background: white;
  color: #1a1a2e;
  text-decoration: none;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f0f0f0;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

function NotFound() {
  return (
    <NotFoundContainer>
      <DynamicBackground />
      <Content>
        <Title>404</Title>
        <Message>Oops! The page you're looking for doesn't exist.</Message>
        <StyledLink to="/">Return Home</StyledLink>
      </Content>
    </NotFoundContainer>
  );
}

export default NotFound;
